/**
 * TanStack Query hooks for `click-spam-detection`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	stats,
	clickSpamDetectionQueryKeys,
	type CreateClickSpamDetectionBody,
	type ListClickSpamDetectionFilters,
	type ListClickSpamDetectionResponse,
	type ClickSpamDetectionStats,
} from "./api";

export function useClickSpamDetectionList(
	filters: ListClickSpamDetectionFilters = {},
): UseQueryResult<ListClickSpamDetectionResponse, Error> {
	return useQuery({
		queryKey: clickSpamDetectionQueryKeys.list(filters),
		queryFn: () => list(filters),
	});
}

export function useClickSpamDetectionStats(): UseQueryResult<ClickSpamDetectionStats, Error> {
	return useQuery({
		queryKey: clickSpamDetectionQueryKeys.stats(),
		queryFn: stats,
	});
}

export function useClickSpamDetectionCreate(): UseMutationResult<
	{ ok: boolean; event_id: string; flagged: boolean; created_at: number },
	Error,
	CreateClickSpamDetectionBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: clickSpamDetectionQueryKeys.all });
		},
	});
}
